import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { toggleDirectory, reorderDirectories } from "../actions";

const DirectoriesTable = () => {
  const dispatch = useDispatch();
  const directories = useSelector((state) => 
    [...state.directories].sort((a, b) => a.mobile_order - b.mobile_order)
  );

  const onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination || source.index === destination.index) return;

    const reordered = Array.from(directories);
    const [moved] = reordered.splice(source.index, 1);
    reordered.splice(destination.index, 0, moved);

    const updated = reordered.map((dir, index) => ({
      ...dir,
      mobile_order: index + 1,
    }));

    dispatch(reorderDirectories(updated));
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="directories" type="DIRECTORY">
        {(provided) => (
          <table
            className="table directories-table"
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            <tbody>
              {directories.map((directory, index) => (
                <Draggable
                  key={`directory-${directory.id}`}
                  draggableId={`directory-${directory.id}`}
                  index={index}
                >
                  {(prov) => (
                    <tr
                      className="directory-row"
                      ref={prov.innerRef}
                      {...prov.draggableProps}
                      {...prov.dragHandleProps}
                    >
                      <td>
                        <div
                          className={`icheckbox_square-orange icheck-item ${
                            directory.mobile_enabled ? "checked" : ""
                          }`}
                          onClick={() => dispatch(toggleDirectory(directory.id))}
                        >
                          <input
                            id={`checkbox${directory.id}`}
                            className="i-checks icheck-input"
                            type="checkbox"
                            checked={directory.mobile_enabled}
                            readOnly
                          />
                        </div>
                      </td>
                      <td>
                        <i className="fa fa-bars drag_handle ui-sortable-handle add-margin-right-5"></i>
                      </td>
                      <td>{directory.name}</td>
                    </tr>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </tbody>
          </table>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DirectoriesTable;
